import { render } from "./BonusForFriends.vue?vue&type=template&id=bf96a91c&scoped=true"
import script from "./BonusForFriends.vue?vue&type=script&lang=js"
export * from "./BonusForFriends.vue?vue&type=script&lang=js"

import "./BonusForFriends.vue?vue&type=style&index=0&id=bf96a91c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf96a91c"]])

export default __exports__